import { UpdateHub } from "@ogaf/scripts/UpdateHub/UpdateHub";
import { TPpdTaskBase } from "../App/PpdBaseTask";
import { TPpdApp } from "../App/PpdApp";

/**
 * Třída pro správu SignalR připojení PPD úlohy.
 * Rozšiřuje UpdateHub pro zpracování zpráv z SignalR komunikace.
 */
export class UpdateHubPpd extends UpdateHub {

    /**
     * Inicializuje novou instanci třídy UpdateHubPpd.
     * Zavolá konstruktor nadřazené třídy UpdateHub.
     */
    constructor() {
        super();
    }

    /**
     * Zpracuje zprávu přijatou ze SignalR připojení.
     * Na základě typu zprávy provede příslušné akce na aplikaci.
     * 
     * @param message - Typ zprávy: "ok" pro úspěšné dokončení, "cancelled" pro zrušení
     * @param uid - Identifikátor asynchronní úlohy
     * @remarks
     * - "ok": Vyčistí ID úlohy a obnoví pohled
     * - "cancelled": Vyčistí ID úlohy a skryje indikátor pokroku
     */
    public override onSignalRConnection(message: string, uid: string) : void {
        const crntTask = CurrentTask as unknown as TPpdTaskBase;
        const app = crntTask.App as unknown as TPpdApp;
        switch (message) {
            case "ok":
                app.AsyncTaskUid = "";
                app.ViewRefresh();
                break;
            case "cancelled":
                app.AsyncTaskUid = "";
                app.HideProgress();
                break;
            default:
                break;
        }
    }

}

Connection = new UpdateHubPpd().Connection;